import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHeading = ({ index, eyebrow, title, subtitle, dark = false, center = false }) => (
  <div className={`flex flex-col gap-5 ${center ? "items-center text-center" : ""}`}>
    <Reveal>
      <div className={`flex items-center gap-4 ${center ? "justify-center" : ""}`}>
        <span className="font-mono text-xs tracking-[0.3em] text-gold">{index}</span>
        <span className="h-px w-12 bg-gold/60" />
        <span className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">{eyebrow}</span>
      </div>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className={`font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight ${dark ? "text-white" : "text-navy"}`}>
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.2}>
        <p className={`max-w-2xl text-base sm:text-lg leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"} ${center ? "mx-auto" : ""}`}>
          {subtitle}
        </p>
      </Reveal>
    )}
  </div>
);
